<template>
  <div class="help-menu">
    <button v-if="currentInterstitialContent" class="help-menu__btn" @click="onHelpRequested">
      <responsive-img
        :width="116"
        alt=""
        class="help-menu__img"
        src="/images/menu_icons/help@3x.png"
      />
    </button>
  </div>
</template>

<script>
  import { mapActions } from 'vuex'
  import { interstitialContentList } from '@/assets/js/model/interstitial-content'
  import { wizardStepList } from '@/assets/js/model/wizard-steps'
  import ResponsiveImg from '@/components/responsive-img/responsive-img'

  export default {
    components: { ResponsiveImg },
    props: {},
    computed: {
      currentWizardStep() {
        return wizardStepList.find(({ param }) => param === this.$route.params.step)
      },
      currentInterstitialContent() {
        return interstitialContentList.find(({ wizardStepId }) => {
          return wizardStepId === this.currentWizardStep.id
        })
      },
    },
    methods: {
      ...mapActions('interstitial', ['setInterstitial']),
      onHelpRequested() {
        this.setInterstitial({
          isOpen: true,
          id: this.currentInterstitialContent.id,
          isHelp: true,
        })
      },
    },
  }
</script>

<style lang="scss" src="./_help-menu.scss" />
